import {useEffect, useState} from 'react'
import {initialQueryState} from '../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponse} from '../../core/QueryResponseTemplosProvider'

const UFS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
  'EX', // EX = Exterior
]

const TemplosListFilter: React.FC<{visible?: boolean}> = ({visible = true}) => {
  const {updateState} = useQueryRequest()
  const {isLoading} = useQueryResponse()
  const [ativo, setAtivo] = useState<string>('1')
  const [uf, setUf] = useState<string>('')

  useEffect(() => {
    // Aplicar filtro padrão (Ativo = SIM) ao carregar
    updateState({
      filter: {in_templo_ativo: '1', tx_sigla: ''},
      ...initialQueryState,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const resetData = () => {
    updateState({filter: undefined, ...initialQueryState})
    setAtivo('1')
    setUf('')
  }

  const filterData = () => {
    updateState({
      filter: {in_templo_ativo: ativo, tx_sigla: uf},
      ...initialQueryState,
    })
  }

  return (
    <div className={`collapse ${visible ? 'show' : ''}`}>
      <div className='px-9 pt-4 pb-6 border-bottom border-gray-300'>
        <div className='row g-4 align-items-end'>
          {/* begin::Ativo */}
          <div className='col-md-3 col-sm-6'>
            <label className='form-label fw-bold fs-7 text-muted text-uppercase mb-2'>Ativo</label>
            <select
              className='form-select form-select-solid form-select-sm fw-bolder'
              onChange={(e) => setAtivo(e.target.value)}
              value={ativo}
            >
              <option value=''>Todos</option>
              <option value='1'>SIM</option>
              <option value='0'>NÃO</option>
            </select>
          </div>
          {/* end::Ativo */}

          {/* begin::UF */}
          <div className='col-md-3 col-sm-6'>
            <label className='form-label fw-bold fs-7 text-muted text-uppercase mb-2'>UF</label>
            <select
              className='form-select form-select-solid form-select-sm fw-bolder'
              onChange={(e) => setUf(e.target.value)}
              value={uf}
            >
              <option value=''>Todas</option>
              {UFS.map((stateUf) => (
                <option key={stateUf} value={stateUf}>
                  {stateUf}
                </option>
              ))}
            </select>
          </div>
          {/* end::UF */}

          {/* begin::Actions */}
          <div className='col-md-auto col-sm-12 d-flex gap-2'>
            <button
              disabled={isLoading}
              type='button'
              onClick={filterData}
              className='btn btn-primary btn-sm fw-bold px-6'
            >
              Aplicar
            </button>
            <button
              type='button'
              disabled={isLoading}
              onClick={resetData}
              className='btn btn-light btn-active-light-primary btn-sm fw-bold px-6'
            >
              Limpar
            </button>
          </div>
          {/* end::Actions */}
        </div>
      </div>
    </div>
  )
}

export {TemplosListFilter}
